import { useMutation, useQuery } from '@tanstack/react-query';

import { OfferUI } from '../common/contracts';
import { EQueryKeys } from '../constants/enums';
import useAxios from '../hooks/useAxios';

import { EApiRoutes, fetchConfig, getApiRouteOrMock } from './api.utils';

export default function useOfferDesign(
  currentPublisherId?: string,
  offerId?: string
) {
  const axios = useAxios();

  const getOfferDesigns = useQuery({
    ...fetchConfig.list,
    queryKey: [EQueryKeys.OFFER_DESIGN],
    queryFn: async () => {
      return await axios.get(
        getApiRouteOrMock(EApiRoutes.OFFER_DESIGN),
        {},
        currentPublisherId ? { 'x-publishers': currentPublisherId } : undefined
      );
    },
    enabled: !!currentPublisherId
  });

  const getOfferDesign = useQuery({
    ...fetchConfig.single,
    queryKey: [`${EQueryKeys.OFFER_DESIGN}_${offerId}`],
    queryFn: async () => {
      return await axios.get(
        `${getApiRouteOrMock(EApiRoutes.OFFER_DESIGN)}/${offerId}`,
        {},
        currentPublisherId ? { 'x-publishers': currentPublisherId } : undefined
      );
    },
    enabled: !!currentPublisherId && !!offerId,
    staleTime: 5 * 60
  });

  const addOfferDesign = useMutation(async (newOfferDesign: OfferUI) => {
    return await axios.post(
      getApiRouteOrMock(EApiRoutes.OFFER_DESIGN),
      newOfferDesign
    );
  }, {});

  const deleteOfferDesign = useMutation(async (offerDesignId: string) => {
    return await axios.del(
      `${getApiRouteOrMock(EApiRoutes.OFFER_DESIGN)}/${offerDesignId}`
    );
  }, {});

  const updateOfferDesign = useMutation(
    async ({ form, offerId }: { form: Partial<OfferUI>; offerId: string }) => {
      return axios.put(
        `${getApiRouteOrMock(EApiRoutes.OFFER_DESIGN)}/${offerId}`,
        form
      );
    },
    {}
  );

  return {
    getOfferDesign,
    getOfferDesigns,
    addOfferDesign,
    deleteOfferDesign,
    updateOfferDesign
  };
}
